import React, {useContext} from "react";
import {ConfigContext, CurrentContext, lengthToType, SetterContext} from "../App";

function TotalPrice() {
    const current = useContext(CurrentContext);
    const config = useContext(ConfigContext);
    const Setter = useContext(SetterContext);

    let price = 0;

    const lengthType = lengthToType(current.length);
    const innerVersion = config.inside.versions.find(v => v.name === current.inside_version)!;

    if (current.seats < innerVersion.includedSeats) {
        Setter("seats")(String(innerVersion.includedSeats));
    }

    price += config.seats.price * (current.seats - innerVersion.includedSeats);

    const outsideConfig = config.car.car
            .find(c =>
                    c.length === current.length
                    && c.engine === current.engine
                    && c.transmission === current.transmission,
            )!;
    price += outsideConfig.price;

    price += config.carPackage.find(p => p.package === current.package)!.price;
    price += config.carColorOutside.find(c => c.name === current.outside_color)!.price;
    price += config.inside.versions.find(
            p =>
                    p.name === current.inside_version
                    && p.typ === lengthType,
    )!.price;
    price += config.tech.techPackage.find(t => t.name === current.tech_package)!.price;

    price += current.tech_optional
            .map((o: string) =>
                    config.tech
                            .techOptional
                            .find(t => t.name === o))
            .reduce(
                    (acc: number, elem: any) => acc + elem.price,
                    0,
            );

    price += current.gadgets
            .map((o: string) =>
                    config.Gagets
                            .find(t => t.name === o))
            .reduce(
                    (acc: number, elem: any) => acc + (
                            current[`amount-${elem.name}`] === undefined
                                    ? elem.price
                                    : elem.price * Number.parseInt(current[`amount-${elem.name}`])

                    ),
                    0,
            );

    if (current.inside_version === "Basic Camper") {
        price += current.modules
                .map((o: string) =>
                        config.modules
                                .find(t => t.name === o))
                .reduce(
                        (acc: number, elem: any) => acc + (typeof elem.price === "number" ? elem.price : (
                                current.length === "5,40m" ? elem.price.l2h2 : elem.price.l3h2
                        )),
                        0,
                );
    }

    return <div className={"price"}>
        {Math.round( price * 1.19 ).toLocaleString( "de" )} € inkl. MwSt.
    </div>;
    // return (
    //         Math.round(price * 1.19).toLocaleString("de")
    // )
}

export default TotalPrice;
